<template>
  <div id="hres7fe">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres7feIndex"
            :editEvent="editEvent"
            searchBoxAlias="hres7fe" /> 

    <detail v-show="detailDisp"
            :searchIndex="searchIndex"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :detail="detail"
            :codeval="codempid"
            :receivedHres7feDetail="receivedHres7feDetail"
            :descCodeval="app.currentUser.username[app.nowLang]"
            :postHres7feTab1Save="postHres7feTab1Save"
            :postHres7feTab2Save="postHres7feTab2Save" />
  </div>
  
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres7fe/mutation-types'
import detail from 'components/hres7fe/detail'
import moment from 'moment'

export default {
  name: 'hres7fe',
  data () {
    return {
      searchIndex: {
        year: moment().format('YYYY'),
        dtestrt: '01' + moment().format('MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY')
      },
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    this.receivedHres7feColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES7FE_INDEX_DISP,
      detailDisp: types.GET_HRES7FE_DETAIL_DISP,
      labels: types.GET_HRES7FE_LABELS,
      index: types.GET_HRES7FE_INDEX,
      columns: types.GET_HRES7FE_COLUMNS,
      indexSelected: types.GET_HRES7FE_INDEX_SELECTED,
      detail: types.GET_HRES7FE_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'edit':
          let searchParams = {
            year: this.searchIndex.year,
            codcours: this.indexSelected.codcours,
            numclseq: this.indexSelected.numclseq
          }
          if (this.indexSelected.numclseq) {
            this.receivedHres7feDetail(searchParams)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES7FE_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES7FE_PAGE,
      receivedHres7feColumnsLabels: types.RECEIVED_HRES7FE_COLUMNS_LABELS,
      receivedHres7feIndex: types.RECEIVED_HRES7FE_INDEX,
      receivedHres7feDetail: types.RECEIVED_HRES7FE_DETAIL,
      postHres7feTab1Save: types.POST_HRES7FE_TAB1_SAVE,
      postHres7feTab2Save: types.POST_HRES7FE_TAB2_SAVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?454272c2